"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontStyleForCss = getFontStyleForCss;
exports.parseFontFamily = parseFontFamily;
exports.toFontValue = toFontValue;
exports.parseCustomFonts = parseCustomFonts;
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const FontDefinitions_1 = require("../fonts/FontDefinitions");
const FontFamilies_1 = __importDefault(require("./FontFamilies"));
/**
 * The renderer does not appreciate it when it is given invalid font-style values
 * and will produce unexpected behavior, so only give it italic or normal.
 *
 * @param value the font style
 */
function getFontStyleForCss(value) {
    if (value === graphql_schema_types_1.FontStyle.Italic) {
        return 'italic';
    }
    return 'normal';
}
/**
 * @param fontFamily the font family
 */
function parseFontFamily(fontFamily) {
    const fontFamilyParts = fontFamily.split(',');
    return fontFamilyParts.map(fontName => fontName.trim().replaceAll(/^'|'$/g, ''));
}
/**
 * We give special consideration to the local fonts since they have complex names that are likely to change.
 * The rest of the fonts must be named identically to the name of the font on the source, so... not needed
 */
function toFontValue(fontString) {
    if (fontString === 'Helvetica') {
        return FontFamilies_1.default.HELVETICA;
    }
    if (fontString === 'Times New Roman') {
        return FontFamilies_1.default.TIMES_NEW_ROMAN;
    }
    return fontString;
}
/**
 * Parses an array of custom fonts into a standardized format.
 **/
function parseCustomFonts(customFonts = []) {
    return customFonts.map(font => {
        return {
            classification: FontDefinitions_1.FontClassification.CUSTOM,
            source: font.source,
            family: font.name,
            styles: font.styles.map(style => (0, FontDefinitions_1.getStyle)(style.weight, style.style)),
            assetNames: font.assetNames
        };
    });
}
//# sourceMappingURL=FontHelper.js.map